// TOOLBAR KEYBOARD NAVIGATION (LEFT/RIGHT)
document.querySelectorAll('[role="toolbar"] button').forEach(button => {
    button.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            // Navigate between toolbar buttons
            const toolbar = button.closest('[role="toolbar"]');
            const buttons = toolbar.querySelectorAll('button');
            const currentIndex = Array.from(buttons).indexOf(button);
            const nextIndex = e.key === 'ArrowRight' ?
                (currentIndex + 1) % buttons.length :
                (currentIndex - 1 + buttons.length) % buttons.length;
            buttons[nextIndex].focus();
            e.preventDefault();
        }
    });
});